<template>
    <v-card>
        <v-card-title>
            <template v-if="isAdmin">
                <v-btn
                    dark
                    color="primary"
                    class="mb-2"
                    :to="{ name: 'CadastrarStaff' }"
                >
                    <v-icon>add</v-icon> {{ $t('legalTeam.list.addItem') }}
                </v-btn>
                <v-divider
                    class="mx-3 hidden-md-and-down mt-0"
                    inset
                    vertical
                ></v-divider>
            </template>
            <v-text-field
                v-model="search.query"
                @click:clear="clearQuery"
                @keyup.enter="loadData()"
                type="text"
                prepend-icon="search"
                :label="$t('common.search.field')"
                clear-icon="cancel"
                clearable
                hide-details
                solo
            ></v-text-field>
            <v-btn
                class="ml-2"
                color="primary"
                :disabled="!search.ready"
                @click="loadData()"
            >{{ $t('common.search.button') }}</v-btn>
            <v-spacer></v-spacer>
            <v-switch
                flat
                inset
                :disabled="!search.ready"
                v-model="dataTable.showInactives"
                :label="$t('common.showInactives')"
            ></v-switch>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <data-table :setup.sync="dataTable" @is_active-item="isActiveItem"></data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'list-staff',
    metaInfo () {
        return {
            title: this.$t('legalTeam.list.meta.title'),
            meta: [
                { name: 'description', content: this.$t('legalTeam.list.meta.description') },
                { name: 'keywords', content: this.$t('legalTeam.list.meta.keywords') }
            ]
        }
    },
    components: {
        DataTable
    },
    data () {
        return {
            isAdmin: false,
            search: {
                ready: true,
                query: ''
            },
            dataTable: {
                loading: true,
                itemName: this.$t('legalTeam.list.dataTable.itemName'),
                headers: [
                    {
                        text: this.$t('legalTeam.list.dataTable.headers.avatar'),
                        value: 'profile.avatar',
                        width: '5%',
                        align: 'center',
                        sortable: false,
                        img: {
                            width: 32,
                            height: 32,
                            else: {
                                key: 'nameLowerCase',
                                value: undefined
                            }
                        }
                    },
                    { text: this.$t('legalTeam.list.dataTable.headers.name'), value: 'user.name', width: '30%' },
                    { text: this.$t('legalTeam.list.dataTable.headers.activeDemands'), value: 'activeDemands', width: '15%', align: 'center' },
                    { text: this.$t('legalTeam.list.dataTable.headers.demandsCompleted'), value: 'demandsCompleted', width: '15%', align: 'center' },
                    { text: this.$t('legalTeam.list.dataTable.headers.workedHours'), value: 'workedHours', width: '15%', align: 'center' }
                ],
                items: [],
                showInactives: false,
                totalItems: 0,
                detailTo: 'StaffDetalheAbaInfo',
                isActiveMessage: this.$t('legalTeam.list.dataTable.isInactiveMessage'),
                isActiveIcon: 'mdi-eye-off',
                editTo: 'EditarStaff',
                pagination: {
                    multiSort: false,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['nameLowerCase'],
                    sortDesc: [false],
                    sortFormated: [
                        { value: 'nameLowerCase', descending: false }
                    ]
                },
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.showInactives': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (val) {
                        this.dataTable.isActiveMessage = this.$t('legalTeam.list.dataTable.isActiveMessage')
                        this.dataTable.isActiveIcon = 'mdi-eye'
                    } else {
                        this.dataTable.isActiveMessage = this.$t('legalTeam.list.dataTable.isInactiveMessage')
                        this.dataTable.isActiveIcon = 'mdi-eye-off'
                    }
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.adminOnly()
        this.loadData()
    },
    methods: {
        adminOnly () {
            if (this.$helpers.isAdmin()) {
                this.isAdmin = true
                this.dataTable.headers[1].width = '35%'
                this.dataTable.headers.push(
                    {
                        text: this.$t('legalTeam.list.dataTable.headers.actions'),
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                        edit: true,
                        isActive: true,
                        width: '15%'
                    }
                )
            }
        },
        clearQuery () {
            this.search.query = ''
            this.loadData()
        },
        getSortFormated (sortArray) {
            const sortFormated = sortArray.map((sortObj) => {
                return `${(sortObj.descending) ? '-' : ''}${sortObj.value}`
            })
            return sortFormated.join()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            this.dataTable.loading = true
            this.search.ready = false
            let endpoint = API.EndPoints.getUserCompany

            const where = {
                client: {
                    __type: 'Pointer',
                    className: 'Client',
                    objectId: this.$helpers.getUserCompany().client.objectId
                },
                isActive: !this.dataTable.showInactives,
                isSystem: false
            }

            if (this.search.query) {
                where['nameLowerCase'] = { $regex: `${this.search.query.toLowerCase()}`, $options: 'i' }
            }

            const params = {
                limit: this.dataTable.pagination.itemsPerPage,
                skip: (this.dataTable.pagination.page - 1) * this.dataTable.pagination.itemsPerPage,
                count: true,
                order: this.getSortFormated(this.dataTable.pagination.sortFormated),
                where: JSON.stringify(where),
                include: ['user']
            }

            await new API(endpoint, params).request()
                .then(response => {
                    this.dataTable.items = response.body.results.map((userCompany) => {
                        return {
                            ...userCompany,
                            color: userCompany.profile?.color ?? '#2980b9'
                        }
                    })
                    this.dataTable.totalItems = response.body.count
                    this.search.ready = true
                    this.dataTable.loading = false
                }, (e) => {
                    this.$helpers.requestError(e)
                })
        },
        async isActiveItem (item) {
            let endpoint = API.EndPoints.editUserCompany
            endpoint.id = item.objectId
            let params = {
                isActive: this.dataTable.showInactives
            }
            let msg = ''
            await new API(endpoint, params).request()
                .then(
                    (resp) => {
                        if (this.dataTable.showInactives) {
                            msg = this.$t('legalTeam.list.dataTable.fbActiveMessage')
                        } else {
                            msg = this.$t('legalTeam.list.dataTable.fbInactiveMessage')
                        }
                    },
                    (error) => { msg = (error.status !== 0) ? error.data.error : '' }
                )
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
